<template>
  <div class="col-12">
    <a id="downloadAnchorElem" style="display: none"></a>
    <Search
      :isImportExcel="true"
      :filterCatch="true"
      :allowFields="$lang.azmoonLang.exam_pack_fildes"
      :hiddenFields="hiddenFields"
      :allowCollapse="false"
      :url="examPack_url"
      :title="$lang.azmoonLang.azmoon_list"
      config="azmoon"
      addModalSize="xl"
      removeModalSize="xl"
      :visibleSearch="true"
      :visibleSettings="true"
      :visibleExport="false"
      :visibleFilters="false"
      :visibleViewCount="true"
      :remove_item="remove_azmoon"
      :allowEdit="false"
      :isLoading="isLoading"
      :dynamicButtons="buttonsAzmoon"
      ref="ExamPackSearch"
      :order_by="`id:desc`"
      @importExcel="importExcel"
      :isImportExcelTooltip="$lang.azmoonLang.exam_pack_enter_file"
      @getPermisson="updatePermissions"
      :visibleAdd="isAdmin(permissions, ['admin'])"
    >
      <template slot="addModal" slot-scope="search">
        <b-card>
          <div slot="header">
            <strong v-text="$lang.azmoonLang.azmoonAdd" />
          </div>
          <AddExamPack @close="search.close" @getItems="getItems" />
        </b-card>
      </template>
    </Search>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="view_azmoon"
      size="xl"
      ok-only
      hide-footer
      hide-header
    >
      <b-card>
        <div slot="header">
          <strong v-text="$lang.upload_exam_pack" />
        </div>
        <ShowCardUpload
          :url="uploadExcelUrl"
          :showAlert="showCardUploadAlertMessage"
          fileKey="exam_pack"
          acceptFormatsInput="application/zip"
          @closeModal="closeModal"
          @getItems="getItems"
        />
      </b-card>
    </b-modal>
    <Confirm
      v-model="confirmData.show"
      :ok-title="$lang.yes"
      :title="$lang.exam_pack_clone"
      :cancel-title="$lang.no"
      :loading="confirmData.loading"
      dynamicClass=""
      @ok="cloneExamPack"
      @cancel="closeCloneConfirm"
    >
      <template #extra-area>
        <div>
          <b-form-checkbox
            v-model="cloneQuestions"
            :value="1"
            :unchecked-value="0"
          >
            <span class="font-size-12 font-weight-bold">
              {{ $lang.clone_questions_checkbox_label }}
            </span>
          </b-form-checkbox>
          <b-form-checkbox
            v-if="showWithAlgorithm"
            v-model="withAlgorithm"
            :value="1"
            :unchecked-value="0"
          >
            <span class="font-size-12 font-weight-bold">
              {{ $lang.withAlgorithmLabel }}
            </span>
          </b-form-checkbox>
          <div class="mt-3">{{ $lang.are_you_sure_clone }}</div>
        </div>
      </template>
    </Confirm>
  </div>
</template>

<script>
import AddExamPack from "./addExamPack";
import ShowCardUpload from "@/components/fileManager/showCardUpload";
import Search from "@/components/base/search";
import Confirm from "@/components/base/confirm";
import { isAdmin, generateApiUrl } from "@/shared/utils";
import { pathOr } from "ramda";

export default {
  name: "search-exam-pack",
  components: {
    Search,
    AddExamPack,
    ShowCardUpload,
    Confirm,
  },
  data() {
    return {
      examPack_url: this.$config.api_url + this.$config.azmoon.exam_pack,
      view_azmoon: false,
      acceptFormats: [
        {
          caption: "فایل فشرده zip",
          value: "20MB",
        },
      ],
      buttonsAzmoon: [
        {
          id: "0",
          name: "edit",
          click: this.changeAzmoon,
        },

        {
          id: "2",
          name: "view",
        },
        {
          id: "4",
          name: "clone",
          click: this.showCloneConfirm,
        },
        {
          id: "5",
          name: "fileExport",
          click: this.getExamPackExport,
          text: this.$lang.azmoonLang.get_all__export_file,
        },
        {
          id: "1",
          name: "delete",
        },
      ],
      permissions: [],
      hiddenFields: ["exam_pack_show_name"],
      isLoading: false,
      cloneQuestions: 0,
      withAlgorithm: 0,
      showWithAlgorithm: false,
      confirmData: {
        show: false,
        loading: false,
        item: null,
      },
    };
  },
  computed: {
    uploadExcelUrl() {
      return generateApiUrl(["azmoon", "exam_pack_import"]);
    },
    showCardUploadAlertMessage() {
      return `در صورتی که پرسشنامه ای با این نام وجود دارد ابتدا باید پرسشنامه حذف نموده و سپس پرسشنامه را مجدد وارد نمایید.`;
    },
  },
  methods: {
    pathOr,
    isAdmin,
    generateApiUrl,
    updatePermissions(permissions) {
      this.permissions = [...permissions];
    },
    closeModal() {
      this.view_azmoon = false;
    },
    async getExamPackExport(item) {
      if (this.isLoading) return;
      try {
        const url = generateApiUrl(["azmoon", "exam_pack_export"], [item.id]);
        const response = await this.$httpService.patch(url);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      }
    },
    importExcel() {
      this.view_azmoon = true;
    },
    showCloneConfirm(item) {
      this.cloneQuestions = 0;
      this.withAlgorithm = 0;
      const correctionMethodAlgorithmId = pathOr(
        1,
        ["correction_method_algorithm_id"],
        item
      );
      const showAsFinal = pathOr(0, ["show_as_final"], item);
      if (correctionMethodAlgorithmId > 1 && showAsFinal === 1) {
        this.showWithAlgorithm = true;
      }

      this.confirmData.item = item;
      this.confirmData.show = true;
    },
    closeCloneConfirm() {
      this.confirmData.item = null;
      this.confirmData.show = false;
    },
    async cloneExamPack() {
      try {
        this.confirmData.loading = true;
        const id = pathOr(null, ["id"], this.confirmData.item);
        const url = generateApiUrl(["azmoon", "exam_pack_clone"], [id]);
        let payload = {
          clone_questions: this.cloneQuestions,
          with_algorithm: this.withAlgorithm,
        };

        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.closeCloneConfirm();
        this.getItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.confirmData.loading = false;
      }
    },
    async remove_azmoon(item) {
      try {
        const url = `${this.examPack_url}/${item.id}`;
        const response = await this.$httpService.delete(url);
        this.$notify.success(response.data.message);
        return true;
      } catch (error) {
        this.$generateError(error);
        throw "error";
      }
    },
    changeAzmoon(item) {
      this.$router.push({
        name: "edit_exam_pack",
        params: {
          id: item.id,
        },
      });
    },
    getItems() {
      this.$refs.ExamPackSearch.getItems();
    },
  },
};
</script>
